import styled from 'styled-components';

export const IconContainer = styled.i`
  margin-right: 12px;
`;
